// ETC
export const FETCH_DEFAULT_COUNTRY = 'FETCH_DEFAULT_COUNTRY';
export const FETCH_DEFAULT_COUNTRY_SUCCESS = 'FETCH_DEFAULT_COUNTRY_SUCCESS';
export const FETCH_DEFAULT_COUNTRY_FAILURE = 'FETCH_DEFAULT_COUNTRY_FAILURE';
export const REQUEST_CATEGORIES = 'REQUEST_CATEGORIES';
export const RECEIVE_CATEGORIES = 'RECEIVE_CATEGORIES';
export const NOT_RECEIVE_CATEGORIES = 'NOT_RECEIVE_CATEGORIES';
export const REQUEST_CURRENCIES = 'REQUEST_CURRENCIES';
export const ADD_LANGUAGES_FOR_USER_STATE = 'ADD_LANGUAGES_FOR_USER_STATE';
export const ADD_CURRENCIES_FOR_USER_STATE = 'ADD_CURRENCIES_FOR_USER_STATE';

// Stats
export const REQUEST_STATS = 'REQUEST_STATS';
export const RECEIVE_STATS = 'RECEIVE_STATS';
export const NOT_RECEIVE_STATS = 'NOT_RECEIVE_STATS';
export const ALREADY_RECEIVE_STATS = 'ALREADY_RECEIVE_STATS';
export const REQUEST_QUESTS_STATS = 'REQUEST_QUEST_STATS';
export const RECEIVE_QUESTS_STATS = 'RECEIVE_QUEST_STATS';
export const NOT_RECEIVE_QUESTS_STATS = 'NOT_RECEIVE_QUEST_STATS';
export const UPDATE_QUEST_STAT = 'UPDATE_QUEST_STAT';
export const SYNC_QUEST_STAT = 'SYNC_QUEST_STAT';

// Uploads
export const UPLOAD_ADD = 'UPLOAD_ADD';
export const UPLOAD_BATCH = 'UPLOAD_BATCH';
export const UPLOAD_START = 'UPLOAD_START';
export const UPLOAD_PROGRESS = 'UPLOAD_PROGRESS';
export const UPLOAD_FAILURE = 'UPLOAD_FAILURE';
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS';
export const UPLOAD_ABORT = 'UPLOAD_ABORT';
export const UPLOAD_ABORT_SUCCESS = 'UPLOAD_ABORT_SUCCESS';
export const UPLOAD_ABORT_FAILURE = 'UPLOAD_ABORT_FAILURE';
export const READ_FAILURE = 'READ_FAILURE';
export const READ_SUCCESS = 'READ_SUCCESS';

// Tutorials
export const CREATE_TUTORIAL = 'CREATE_TUTORIAL';
export const UPDATE_TUTORIAL_INDEX = 'UPDATE_TUTORIAL_INDEX';
export const CLOSE_TUTORIAL = 'CLOSE_TUTORIAL';
export const FINISH_TUTORIAL = 'FINISH_TUTORIAL';
export const RESET_TUTORIAL = 'RESET_TUTORIAL';
export const UPDATE_UNFINISHED_TUTORIALS_COUNT =
  'UPDATE_UNFINISHED_TUTORIALS_COUNT';

// Network
export const NETWORK_ERROR = 'NETWORK_ERROR';
export const NETWORK_ACCESS_DENIED = 'NETWORK_ACCESS_DENIED';
export const NETWORK_CONFLICT = 'NETWORK_CONFLICT';
export const NETWORK_SERVER_ERROR = 'NETWORK_SERVER_ERROR';
export const NETWORK_UNAUTHORIZED = 'NETWORK_UNAUTHORIZED';
export const NETWORK_DEFAULT_ERROR = 'NETWORK_DEFAULT_ERROR';
export const RESET_NETWORK_ERROR = 'RESET_NETWORK_ERROR';
export const RESET_NETWORK_ERRORS = 'RESET_NETWORK_ERRORS';
export const NETWORK_BAD_REQUEST = 'NETWORK_BAD_REQUEST';
export const CUSTOM_ERROR = 'CUSTOM_ERROR';

// Analytics
export const AUTHORS_LOGGED = 'AUTHORS_LOGGED';
export const ANALYTICS_TRACK_EVENT = 'ANALYTICS_TRACK_EVENT';
export const ANALYTICS_USER_UPDATE = 'ANALYTICS_USER_UPDATE';

// Languages & Currencies
export const REQUEST_LANGUAGES = 'REQUEST_LANGUAGES';
export const RECEIVE_LANGUAGES = 'RECEIVE_LANGUAGES';
export const FETCH_LANGUAGES = 'FETCH_LANGUAGES';
export const FETCH_LANGUAGES_SUCCESS = 'FETCH_LANGUAGES_SUCCESS';
export const FETCH_LANGUAGES_FAILURE = 'FETCH_LANGUAGES_FAILURE';
export const FETCH_CURRENCIES = 'FETCH_CURRENCIES';
export const FETCH_CURRENCIES_SUCCESS = 'FETCH_CURRENCIES_SUCCESS';
export const FETCH_CURRENCIES_FAILURE = 'FETCH_CURRENCIES_FAILURE';

// Reports
export const FETCH_REPORTS_SUMMARY = 'FETCH_REPORTS_SUMMARY';
export const FETCH_REPORTS_SUMMARY_SUCCESS = 'FETCH_REPORTS_SUMMARY_SUCCESS';
export const FETCH_REPORTS_SUMMARY_FAILURE = 'FETCH_REPORTS_SUMMARY_FAILURE';
export const FETCH_REPORTS_SALES = 'FETCH_REPORTS_SALES';
export const FETCH_REPORTS_SALES_SUCCESS = 'FETCH_REPORTS_SALES_SUCCESS';
export const FETCH_REPORTS_SALES_FAILURE = 'FETCH_REPORTS_SALES_FAILURE';
export const FETCH_PAYOUTS = 'FETCH_PAYOUTS';
export const FETCH_PAYOUTS_SUCCESS = 'FETCH_PAYOUTS_SUCCESS';
export const FETCH_PAYOUTS_FAILURE = 'FETCH_PAYOUTS_FAILURE';
